module.exports = __webpack_public_path__ + "img/tail.cb26f7df.png";